/* ============================================================
   Canadian Laser Supply — Volume Pricing (discount-Function model)
   Quantity is NOT a variant. Tiers come from a metafield:
     product.metafields.volume_pricing.tiers  (override)
     shop.metafields.volume_pricing.default_tiers  (default)
   Shape: { "1":0, "5":10, "10":15, "20":20, "50":25 }  (qty -> percent off)
   Buttons set the quantity; a Shopify discount Function applies the % at checkout.
   This script only sets quantity + shows the projected price.
   ============================================================ */
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    var root = document.querySelector("[data-vp]");
    if (!root) return; // volume pricing not enabled on this product

    var qtyInput = document.querySelector(".qty-input");
    var tiersWrap = root.querySelector("[data-vp-tiers]");
    var totalEl = root.querySelector("[data-vp-total]");
    var unitEl = root.querySelector("[data-vp-unit]");
    var saveEl = root.querySelector("[data-vp-save]");
    var noteEl = root.querySelector("[data-vp-note]");

    var numOptions = window.productNumOptions || 0;

    function formatMoney(cents) {
      var fmt = window.shopMoneyFormat || "${{amount}}";
      var d = (cents / 100).toFixed(2);
      return fmt
        .replace("{{amount}}", d)
        .replace("{{amount_no_decimals}}", Math.round(cents / 100))
        .replace("{{amount_with_comma_separator}}", d.replace(".", ","));
    }

    // Parse tiers -> sorted [{qty, pct}]
    var tiers = [];
    try {
      var raw = JSON.parse(root.getAttribute("data-tiers")) || {};
      if (Array.isArray(raw)) {
        tiers = raw.map(function (t) { return { qty: Number(t.qty), pct: Number(t.discount != null ? t.discount : t.pct) }; });
      } else {
        tiers = Object.keys(raw).map(function (k) { return { qty: Number(k), pct: Number(raw[k]) }; });
      }
    } catch (e) { tiers = []; }
    tiers = tiers.filter(function (t) { return !isNaN(t.qty) && !isNaN(t.pct); })
                 .sort(function (a, b) { return a.qty - b.qty; });
    if (!tiers.length) return;

    var variants = null;
    var selectedQty = tiers[0].qty;

    // Reconstruct the currently selected size/VHB variant from active chips.
    function currentOpts() {
      var opts = [];
      for (var i = 0; i < numOptions; i++) opts[i] = undefined;
      document.querySelectorAll("[data-option][data-value].active").forEach(function (el) {
        var idx = parseInt(el.dataset.option, 10);
        if (!isNaN(idx)) opts[idx] = el.dataset.value;
      });
      return opts;
    }

    function currentUnitCents() {
      if (!variants) return null;
      if (numOptions === 0) return variants[0] ? variants[0].price : null;
      var opts = currentOpts();
      var v = variants.find(function (vv) {
        for (var j = 0; j < numOptions; j++) {
          if (opts[j] !== undefined && vv["option" + (j + 1)] !== opts[j]) return false;
        }
        return true;
      });
      if (!v) v = variants.find(function (vv) { return vv.available; }) || variants[0];
      return v ? v.price : null;
    }

    // Highest tier percent whose qty threshold is met.
    function pctForQty(qty) {
      var best = 0;
      tiers.forEach(function (t) { if (qty >= t.qty && t.pct > best) best = t.pct; });
      return best;
    }

    function renderButtons() {
      tiersWrap.innerHTML = "";
      tiers.forEach(function (t) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "vp-tier" + (t.qty === selectedQty ? " active" : "");
        btn.dataset.qty = t.qty;
        btn.innerHTML =
          '<span class="vp-qty">' + t.qty + "</span>" +
          '<span class="vp-qty-label">' + (t.qty === 1 ? "piece" : "pieces") + "</span>" +
          '<span class="vp-each" data-each></span>' +
          (t.pct > 0
            ? '<span class="vp-badge">Save ' + t.pct + "%</span>"
            : '<span class="vp-badge vp-badge--empty">&nbsp;</span>');
        btn.addEventListener("click", function () {
          selectedQty = t.qty;
          if (qtyInput) {
            qtyInput.value = t.qty;
            qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
          }
          update();
        });
        tiersWrap.appendChild(btn);
      });
    }

    function update() {
      var unit = currentUnitCents();
      if (unit == null) return;

      // Per-button "/ea" + active state
      tiersWrap.querySelectorAll(".vp-tier").forEach(function (btn) {
        var q = parseInt(btn.dataset.qty, 10);
        var p = 0;
        tiers.forEach(function (t) { if (t.qty === q) p = t.pct; });
        var each = btn.querySelector("[data-each]");
        if (each) each.innerHTML = formatMoney(Math.round(unit * (1 - p / 100))) + "<small>/ea</small>";
        btn.classList.toggle("active", q === selectedQty);
      });

      var qty = selectedQty;
      var pct = pctForQty(qty);
      var perUnit = Math.round(unit * (1 - pct / 100));
      var total = perUnit * qty;
      var full = unit * qty;

      if (totalEl) totalEl.textContent = formatMoney(total);
      if (unitEl) unitEl.textContent = formatMoney(perUnit) + " per piece";

      if (saveEl) {
        if (full > total) {
          saveEl.innerHTML = "You save " + formatMoney(full - total) +
            "<small>vs " + formatMoney(full) + " at single price</small>";
          saveEl.classList.add("is-active");
        } else {
          saveEl.innerHTML = "";
          saveEl.classList.remove("is-active");
        }
      }
      if (noteEl) {
        noteEl.textContent = pct > 0
          ? "Discount applies automatically in your cart."
          : "Pick a higher quantity to unlock volume pricing.";
      }
    }

    // Recompute when the size/VHB variant changes (after the theme's handler runs).
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-option][data-value]")) setTimeout(update, 0);
    });

    // Manual quantity edits snap the highlight/readout to the applicable tier.
    if (qtyInput) {
      qtyInput.addEventListener("change", function () {
        var q = parseInt(qtyInput.value, 10) || 1;
        // exact tier match keeps that button active; otherwise clear selection highlight
        var exact = tiers.some(function (t) { return t.qty === q; });
        selectedQty = exact ? q : q;
        update();
      });
    }

    fetch("/products/" + window.productHandle + ".js")
      .then(function (r) { if (!r.ok) throw new Error("variant fetch " + r.status); return r.json(); })
      .then(function (data) { variants = data.variants; renderButtons(); update(); })
      .catch(function (err) {
        console.warn("Volume pricing: variant fetch failed.", err);
        renderButtons(); update();
      });
  });
})();
